import React from 'react';
import { useState } from 'react';
import TraderList from './TraderList';
import AddTraderList from './AddTraderList';
import { CancelToken } from 'apisauce';
import { useEffect } from 'react';

export default function Traders({ details, type, }) {
  const [showTraderRequest, setShowTraderRequest] = useState(false);
  const [allowTrading, setAllowTrading] = useState()


  useEffect(() => {
    setAllowTrading(() => allowEUATrading(details))
    
  }, [details])


  const allowEUATrading = (companyDetails) => {

    // if(!companyDetails?.unionRegistryAccount) {
    //   return false;
    // }  
    let content = [];
    if(!companyDetails?.regAddress) {
      content.push('Address');
      console.log( "checkkkk2222")
    }
    if(!companyDetails?.countryName) {
      content.push('Country');
      console.log( "country2")
    }
    if(!companyDetails?.stateName) {
      content.push('State');
      console.log( "state")
    }
    if(!companyDetails?.companyWebsite) {
      content.push('Website');
      console.log( "website")
    }
    if(!companyDetails?.entityType) {
      content.push('Entity Type');
      console.log( "entity")
    }
    if(!companyDetails?.zipCode) {
      content.push('Zip Code');
    }
    // if(!companyDetails?.euaBalance && companyDetails?.euaBalance != 0) {
    //   return false;
    // }
    // if(!companyDetails?.euaBalanceAttachment) {
    //   return false;
    // }
  
    if(content.length > 0) {
      return content.join(', ');
    }
    return false;
  }

 

  return (
    <div>
      {!showTraderRequest && (
        <TraderList
          type={type}
          companyId={details?._id}
          showTraderRequest={() => {
            setShowTraderRequest(true);
            
          }}
          allowTrading={allowTrading}
          blockedStatus={details?.status}
        />
      )}
      {showTraderRequest && (
        <AddTraderList
          companyId={details?._id}
          handleClose={() => {
            setShowTraderRequest(false);
          }}
        />
      )}
    </div>
  );
}
